import { Box, styled } from '@mui/material';

export const ViewerBox = styled(Box)(({ theme }) => ({
  '& .ProseMirror': {
    fontFamily: 'Montserrat, sans-serif',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',

    ':focus-visible': { outline: 'none' },

    p: { margin: '0 0 8px', overflowWrap: 'anywhere' },

    a: {
      color: theme.palette.secondary.main,
    },
  },
}));
